export const shouldRenderReferralPortal = ({ pathname }) => pathname.startsWith("/parrainage");
